import { render, staticRenderFns } from "./FormContentTypeComponent.vue?vue&type=template&id=8ccacb42&scoped=true"
import script from "./FormContentTypeComponent.vue?vue&type=script&lang=js"
export * from "./FormContentTypeComponent.vue?vue&type=script&lang=js"
import style0 from "./FormContentTypeComponent.vue?vue&type=style&index=0&id=8ccacb42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ccacb42",
  null
  
)

export default component.exports